export default __webpack_public_path__ + "static/media/active-info.328545d6.svg";